module.exports = __webpack_public_path__ + "img/detail-pic.0a2dade3.png";